export default __webpack_public_path__ + "static/media/blobs-no-2.7c202732.ogg";